// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { SCREENS } from './NavigationRedux'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  onChangeError: ['error'],
	onChangeErrorRequest: ['error'],
	onSetFetching: ['fetching'],
	onStartFetching: null,
	onStopFetching: null,
	onSetScreenValidateSig: ['screen', 'value'],
	onSetScreensValidateSig: ['screens', 'value'],
	onSetScreenIsValid: ['screen', 'valid'],
	onSetScreensMustBeValid: ['screens'],
	onSetScreenMustBeValid: ['screen', 'valid'],
	onChangeRedirectUrl: ['redirectUrl'],
})

export const GeneralTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({ // eslint-disable-line
  error: {},
	fetching: false,
	screenIsValid: Object.values(SCREENS).map(() => false),
	screenValidateSig: Object.values(SCREENS).map(screen => ({
		validate: false,
		screen
	})),
	screenMustBeValid: Object.values(SCREENS).map(() => false),
	redirectUrl: '',
})

/* ------------- Reducers ------------- */

export const changeError = (state, { error }) =>
  state.merge({ error })

export const changeErrorRequest = (state, { error }) =>
	state.merge({ error, fetching: false })

export const setFetching = (state, { fetching }) =>
	state.merge({ fetching })

export const startFetching = state =>
	setFetching(state, { fetching: true })

export const stopFetching = state =>
	setFetching(state, { fetching: false })

export const setScreenValidateSig = (state, { screen, value }) => {
	const screenValidateSig = [...state.screenValidateSig]
	screenValidateSig[screen] = {
		validate: value,
		screen
	}
	return state.merge({ screenValidateSig })
}

export const setScreensValidateSig = (state, { screens, value }) => {
	const screenValidateSig = state.screenValidateSig.map((validate, index) => {
		if (screens.indexOf(index) !== -1) {
			return {
				validate: value,
				screen: index
			}
		}
 		return validate
	})
	return state.merge({ screenValidateSig })
}

export const setScreenIsValid = (state, { screen, valid }) => {
	const screenIsValid = [...state.screenIsValid]
	screenIsValid[screen] = valid
	const screenValidateSig = [...state.screenValidateSig]
	screenValidateSig[screen] = {
		validate: false,
		screen
	}
	return state.merge({ screenIsValid, screenValidateSig })
}

export const setScreensMustBeValid = (state, { screens }) => {
	const screenMustBeValid = state.screenMustBeValid.map((valid, index) => screens.indexOf(index) !== -1)
	return state.merge({ screenMustBeValid })
}

export const setScreenMustBeValid = (state, { screen, valid }) => {
	const screenMustBeValid = [...state.screenMustBeValid]
	screenMustBeValid[screen] = valid
	return state.merge({ screenMustBeValid })
}

export const onChangeRedirectUrlR = (state, { redirectUrl }) =>
	state.merge({ redirectUrl })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_CHANGE_ERROR]: changeError,
	[Types.ON_SET_FETCHING]: setFetching,
	[Types.ON_START_FETCHING]: startFetching,
	[Types.ON_STOP_FETCHING]: stopFetching,
	[Types.ON_CHANGE_ERROR_REQUEST]: changeErrorRequest,
	[Types.ON_SET_SCREEN_VALIDATE_SIG]: setScreenValidateSig,
	[Types.ON_SET_SCREENS_VALIDATE_SIG]: setScreensValidateSig,
	[Types.ON_SET_SCREEN_IS_VALID]: setScreenIsValid,
	[Types.ON_SET_SCREENS_MUST_BE_VALID]: setScreensMustBeValid,
	[Types.ON_SET_SCREEN_MUST_BE_VALID]: setScreenMustBeValid,
	[Types.ON_CHANGE_REDIRECT_URL]: onChangeRedirectUrlR,
})
